<script lang="ts">
    import { getTrackingService } from '$lib/global/tracking/TrackingServiceInstance';
    import { getCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';

    import EmbedView from './Embed.View.svelte';
    import { hasExternalContentOverlay as getHasExternalContentOverlay } from './helpers';
    import ExternalContentOverlay from '../../ConsentOverlay/ExternalContent/ExternalContent.svelte';

    import type { EmbedContent } from '$lib/types/Components/Embed/EmbedContent';
    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let content: EmbedContent;
    export let id = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let cookiesEnabled = false;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let language: Language = 'en';
    export let trackingProperties: TrackingProperty[];
    export let globalVariables: Record<string, string> = {
        userId: getTrackingService().userId,
    };
    export let nextPage = '';

    const cookies = getCookiePreferences(campaignId, campaignVersionId);

    $: hasAcceptedMediaOverlay = cookies.Media || $mediaCookiesAccepted;
    $: hasExternalContentOverlay = getHasExternalContentOverlay({
        content,
        cookiesEnabled,
        hasAcceptedMediaOverlay,
    });
</script>

{#if hasExternalContentOverlay}
    <ExternalContentOverlay
        {campaignId}
        {campaignVersionId}
        {language}
        {transitionDelay}
        {transitionEffect}
        bgColor={content.box.backgroundColor}
    />
{:else}
    <EmbedView
        box={content.box}
        head={content.head}
        body={content.body}
        src={content.src}
        provider={content.provider}
        bgColor={content.box.backgroundColor}
        enforceCenteredCustomHtmlContent={content.enforceCenteredCustomHtmlContent}
        embedCustomHtmlNatively={content.embedCustomHtmlNatively}
        {id}
        {campaignId}
        {transitionDelay}
        {transitionEffect}
        {trackingProperties}
        {globalVariables}
        {nextPage}
    />
{/if}
